/**
 * @typedef {Record<number,string>} Master
 * @typedef {Array<{id: number, value: string}>} MasterForJs
 */
/**
 * @import { InjectionKey } from vue
 */

/** @type {InjectionKey<Master>} */
export const GenderMasterKey = Symbol()
/** @type {InjectionKey<Master>} */
export const HumanitiesOrScienceMasterKey = Symbol()
/** @type {InjectionKey<Master>} */
export const SchoolDepartmentMasterKey = Symbol()
